// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__-LM04","content":"styles_content__2-G3u","checkbox":"styles_checkbox__2BI_H","checkboxLabel":"styles_checkboxLabel__XZwQL"};